import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { useAppSelector } from 'hooks/useAppSelector';
import { SmartQuotePrompt } from 'state/workspaces/smart-quote/model';
import { getTabPrompts } from 'state/workspaces/smart-quote/selectors';

export const useSortPromptsByCreationDate = (tabId: string): SmartQuotePrompt[] => {
  const tabPrompts = useAppSelector(state => getTabPrompts(state, tabId));
  return Object.values(tabPrompts).sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
};

export const useHasActiveTabSmartQuotePrompts = () => {
  const tabId = useAssertedActiveTabId();
  const prompts = useSortPromptsByCreationDate(tabId);
  return prompts.length > 0;
};
